var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { AttributeGroupTypeIcon, CustomPageTypeIcon, EnumTypeIcon, ProfileTypeIcon, TableTypeIcon } from './custom';
var ICON_MAP = {
    table: TableTypeIcon,
    custom: CustomPageTypeIcon,
    group: AttributeGroupTypeIcon,
    enum: EnumTypeIcon,
    profile: ProfileTypeIcon,
};
var TarasaIcon = function (_a) {
    var name = _a.name, color = _a.color, highlight = _a.highlight, _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, size = _a.size;
    var IconComponent = ICON_MAP[name];
    var resolvedColor = color !== null && color !== void 0 ? color : 'default';
    var resolvedHighlight = highlight !== null && highlight !== void 0 ? highlight : resolvedColor;
    var resolvedWidth = size !== undefined ? size : width;
    var resolvedHeight = size !== undefined ? size : height;
    if (!IconComponent) {
        return null;
    }
    return (React.createElement(Wrapper, null,
        React.createElement(IconComponent, { color: resolvedColor, highlight: resolvedHighlight, width: resolvedWidth, height: resolvedHeight })));
};
var Wrapper = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-flex;\n    align-self: center;\n"], ["\n    display: inline-flex;\n    align-self: center;\n"])));
TarasaIcon.Wrapper = Wrapper;
export { TarasaIcon };
var templateObject_1;
